(function () {
  'use strict';

  var playerPromise;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function iconsIn(root) {
    var icons = [];
    if (!root || root.nodeType !== 1) return icons;
    if (root.matches && root.matches('[data-shipping-lottie]')) icons.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-shipping-lottie]').forEach(function (icon) { icons.push(icon); });
    }
    return icons;
  }

  function loadPlayer(url) {
    if (window.lottie && typeof window.lottie.loadAnimation === 'function') return Promise.resolve(window.lottie);
    if (playerPromise) return playerPromise;

    playerPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-shipping-lottie-player]');
      var script = existing || document.createElement('script');

      function ready() {
        if (window.lottie && typeof window.lottie.loadAnimation === 'function') resolve(window.lottie);
        else reject(new Error('lottie_player_unavailable'));
      }

      script.addEventListener('load', ready, { once: true });
      script.addEventListener('error', reject, { once: true });

      if (!existing) {
        script.src = url;
        script.defer = true;
        script.dataset.shippingLottiePlayer = '';
        document.head.appendChild(script);
      }
    });

    return playerPromise;
  }

  function setup(icon, lottie) {
    if (icon.dataset.shippingLottieReady === 'true') return;
    icon.dataset.shippingLottieReady = 'true';

    var animation = lottie.loadAnimation({
      container: icon,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: icon.dataset.animationUrl,
      rendererSettings: { preserveAspectRatio: 'xMidYMid meet' }
    });

    icon.mvcShippingAnimation = animation;

    animation.addEventListener('DOMLoaded', function () {
      icon.classList.add('is-ready');
      animation.goToAndStop(0, true);
      if (!reduceMotion) animation.play();
    });

    if (!reduceMotion) {
      var trigger = icon.closest('.physical-shipping-note, .yarn-shipping-note, .fulfillment-note, .physical-trust-item') || icon;
      trigger.addEventListener('mouseenter', function () {
        animation.stop();
        animation.play();
      });
    }
  }

  function init(root) {
    var icons = iconsIn(root);
    if (!icons.length) return;

    var playerUrl = icons[0].dataset.playerUrl;
    if (!playerUrl) return;

    loadPlayer(playerUrl).then(function (lottie) {
      icons.forEach(function (icon) { setup(icon, lottie); });
    }).catch(function () {
      icons.forEach(function (icon) { icon.dataset.shippingLottieReady = 'fallback'; });
    });
  }

  function destroy(root) {
    iconsIn(root).forEach(function (icon) {
      if (icon.mvcShippingAnimation && typeof icon.mvcShippingAnimation.destroy === 'function') {
        icon.mvcShippingAnimation.destroy();
      }
    });
  }

  function start() {
    init(document.documentElement);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.removedNodes.forEach(destroy);
        mutation.addedNodes.forEach(init);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());
